import { lowerCase, startCase } from "lodash"

export const normalizedStartCase = (value) => startCase(lowerCase(value))
